import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuardApp } from './core/guards/auth.guard';
import { EmptyRouteComponent } from './empty-route.component';
import { APP_BASE_HREF } from '@angular/common';
import { UnauthComponent } from './shared/components/unauth/unauth.component';
import { MaintenanceModeComponent } from '../app/shared/components/maintenance-mode/maintenance-mode.component';

const routes: Routes = [
  {
    path: 'db',
    loadChildren: () => import('./modules/dbpersona/dbpersona.module').then((m) => m.DbPersonaModule),
    canActivate: [AuthGuardApp],
  },
  {
    path: 'scheduler',
    loadChildren: () =>
      import('./modules/schedulerpersona/schedulerpersona.module').then((m) => m.SchedulerpersonaModule),
    canActivate: [AuthGuardApp],
  },
  {
    path: 'offerdb',
    loadChildren: () => import('./modules/offerdb/offerdb.module').then((m) => m.OfferDbModule),
    canActivate: [AuthGuardApp],
  },
  {
    path: 'recruiter',
    loadChildren: () =>
      import('./modules/recruiterpersona/recruiterpersona.module').then((m) => m.RecruiterpersonaModule),
    canActivate: [AuthGuardApp],
  },
  {
    path: 'rm',
    loadChildren: () => import('./modules/rmpersona/rmpersona.module').then((m) => m.RmpersonaModule),
    canActivate: [AuthGuardApp],
  },
  {
    path: 'recleadam',
    loadChildren: () => import('./modules/recleadpersona/recleadpersona.module').then((m) => m.RecleadpersonaModule),
    canActivate: [AuthGuardApp],
  },
  {
    path: 'reclead',
    loadChildren: () => import('./modules/recleadpersona/recleadpersona.module').then((m) => m.RecleadpersonaModule),
    canActivate: [AuthGuardApp],
  },
  {
    path: 'hroperations',
    loadChildren: () => import('./modules/hroperations/hroperations.module').then((m) => m.HroperationsModule),
    canActivate: [AuthGuardApp],
  },
  {
    path: 'operations',
    loadChildren: () => import('./modules/operations/operations.module').then((m) => m.OperationsModule),
    canActivate: [AuthGuardApp],
  },
  {
    path: 'hiringmanager',
    loadChildren: () => import('./modules/hiringmanager/hiring.module').then((m) => m.HiringModule),
    canActivate: [AuthGuardApp],
  },
  {
    path: 'iaprecruiter',
    loadChildren: () => import('./modules/iap/iap.module').then((m) => m.IAPModule),
    canActivate: [AuthGuardApp],
  },
  {
    path: 'docketanchor',
    loadChildren: () => import('./modules/docket/docket.module').then((m) => m.DOCKETModule),
    canActivate: [AuthGuardApp],
  },
  {
    path: 'maintenance',
    component: MaintenanceModeComponent,
  },
  { path: 'unauth', component: UnauthComponent },
  { path: '**', component: EmptyRouteComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [{ provide: APP_BASE_HREF, useValue: '/' }],
})
export class AppRoutingModule {}
